import { get } from "lodash";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  data() {
    return {
      geoRegionOptions: [],
      geoAreaOptions: [],
      geoDistrictOptions: [],
      geoAssemblyOptions: [],
      loadingGeoData: false,
    };
  },
  methods: {
    async fetchGeoRegions() {
      try {
        this.loadingGeoData = true;

        const request = await this.useJwt().sharedService.fetchGeoRegions();
        const { data } = request.data;
        const options = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
        this.geoRegionOptions = options;
        return options;
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loadingGeoData = false;
      }
    },
    async fetchGeoAreas(region_id) {
      try {
        this.loadingGeoData = true;

        if (!region_id) {
          return;
        }
        const request = await this.useJwt().sharedService.fetchGeoAreas({
          region_id,
        });
        const { data } = request.data;
        const options = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
        this.geoAreaOptions = options;
        return options;
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loadingGeoData = false;
      }
    },
    async fetchGeoAssemblies(district_id) {
      try {
        this.loadingGeoData = true;

        if (!district_id) {
          return;
        }

        const request = await this.useJwt().sharedService.fetchGeoAssemblies({
          district_id,
        });
        const { data } = request.data;
        const options = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
        this.geoAssemblyOptions = options;
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loadingGeoData = false;
      }
    },
    async fetchGeoDistricts(area_id) {
      try {
        this.loadingGeoData = true;

        if (!area_id) {
          return;
        }

        const request = await this.useJwt().sharedService.fetchGeoDistricts({
          area_id,
        });
        const { data } = request.data;
        const options = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
        this.geoDistrictOptions = options;
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loadingGeoData = false;
      }
    },
  },
};
